import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    backend: {
      // Load translations from the API.
      // The API returns JSON with a top-level "translation" object.
      loadPath: "https://api.psanalytics.co.uk/ncjp/translations?lang={{lng}}",
      parse: (data: string) => JSON.parse(data).translation
    },
    lng: "en",
    fallbackLng: "en",
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: { escapeValue: false },
    react: {
      useSuspense: true // Use Suspense to wait for translations to load
    }
  });

export default i18n;
